import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

interface MessageDialogProps {
    title: string;
    message: string;
    open: boolean;
    onClose: () => void;
    confirmText?: string;
}

export const MessageDialog: React.FC<MessageDialogProps> = ({
    title,
    message,
    open,
    onClose,
    confirmText = "OK"
}) => {
    return (
        <Dialog.Root open={open} onOpenChange={onClose}>
            <Dialog.Portal>
                {/* Overlay for dimmed background */}
                <Dialog.Overlay 
                    className="fixed inset-0 bg-black/50  data-[state=open]:animate-overlayShow z-50" 
                />
                
                {/* Content wrapper */}
                <Dialog.Content 
                    className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] 
                               w-[90vw] max-w-sm bg-white rounded-lg shadow-2xl p-6  z-60 
                               data-[state=open]:animate-contentShow focus:outline-none"
                >
                    <Dialog.Title className="text-xl font-bold mb-2 text-red-600">
                        {title}
                    </Dialog.Title>
                    
                    <Dialog.Description className="text-gray-700 mb-6">
                        {message}
                    </Dialog.Description>

                    <div className="flex justify-end">
                        <Dialog.Close asChild>
                            <button 
                                onClick={onClose}
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                            >
                                {confirmText}
                            </button>
                        </Dialog.Close>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
